const DEFAULT_LOCAL_URL = 'http://localhost:8084/rest';

/**
 * Dev (`npm start` / `npm run dev`) → REACT_APP_API_BASE_URL_LOCAL
 * Production build (`npm run build`) → REACT_APP_API_BASE_URL_PROD
 *
 * Falls back to legacy REACT_APP_API_BASE_URL, then localhost.
 */
function resolveApiBaseUrl() {
  const isProdBuild = process.env.NODE_ENV === 'production';
  if (isProdBuild) {
    return (
      process.env.REACT_APP_API_BASE_URL_PROD ||
      process.env.REACT_APP_API_BASE_URL ||
      DEFAULT_LOCAL_URL
    );
  }
  return (
    process.env.REACT_APP_API_BASE_URL_LOCAL ||
    process.env.REACT_APP_API_BASE_URL ||
    DEFAULT_LOCAL_URL
  );
}

export const API_BASE_URL = resolveApiBaseUrl();

/** When false, repositories fall back to local mock data where implemented. */
export const USE_API = process.env.REACT_APP_USE_API !== 'false';

export const TOKEN_KEYS = {
  access: 'utkarsh_access_token',
  refresh: 'utkarsh_refresh_token',
  staff: 'utkarsh_auth_staff',
  permissions: 'utkarsh_auth_permissions',
  isSuperAdmin: 'utkarsh_auth_is_super_admin',
};
